export const instrumentDraft = row => ({
  leverage: row.local_leverage == null ? '' : String(row.local_leverage),
  spread: String(row.spread ?? 0), spread_type: row.spread_type || 'variable',
  swap_long: String(row.swap_long ?? 0), swap_short: String(row.swap_short ?? 0),
});

export const instrumentChanges = (draft, original) => {
  const changes = {};
  for (const key of Object.keys(draft)) {
    if (draft[key] === original[key]) continue;
    const text = draft[key].trim();
    if (key === 'spread_type') { changes[key] = text; continue; }
    if (key === 'leverage') {
      if (!text) { changes[key] = null; continue; }
      const raw = text.replace(/^1\s*:\s*/, '');
      const value = Number(raw);
      if (!/^\d+$/.test(raw) || !Number.isInteger(value) || value < 1 || value > 10000) throw new Error('Kaldıraç 1 ile 10000 arasında tam sayı olmalı.');
      changes[key] = value;
    } else {
      if (!text || !Number.isFinite(Number(text)) || (key === 'spread' && Number(text) < 0)) throw new Error(key === 'spread' ? 'Alış-satış farkı sıfır veya pozitif olmalı.' : 'Gecelik faiz için geçerli bir sayı girin.');
      changes[key] = Number(text);
    }
  }
  return changes;
};